import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export function Card({
  className,
  ...rest
}: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div className={cn('surface-card', className)} {...rest} />;
}

export function CardHeader({
  className,
  ...rest
}: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={cn('px-6 py-4 border-b border-[var(--color-border)]', className)}
      {...rest}
    />
  );
}

export function CardBody({
  className,
  ...rest
}: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div className={cn('p-6', className)} {...rest} />;
}

export function CardTitle({
  className,
  ...rest
}: HTMLAttributes<HTMLHeadingElement>): JSX.Element {
  return (
    <h2
      className={cn('font-display', className)}
      style={{ fontSize: 17, lineHeight: '24px', fontWeight: 600 }}
      {...rest}
    />
  );
}

export function CardSubtitle({
  className,
  ...rest
}: HTMLAttributes<HTMLParagraphElement>): JSX.Element {
  return (
    <p
      className={cn(className)}
      style={{
        fontSize: 13,
        lineHeight: '18px',
        color: 'var(--color-fg-muted)',
        marginTop: 4,
      }}
      {...rest}
    />
  );
}
